import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'environments/environment';
@Injectable({
  providedIn: 'root'
})
export class IntransitService {

  constructor(private _http: HttpClient) { }

  getData(formdata: any): Observable<any> {
    return this._http
      .post(`${environment.apiUrl}in-transit`,formdata)
      .pipe(
        map(data => {
          return data;
        })
      );
  }

  getmeta(id: string): Observable<any> {
    return this._http.post(`${environment.apiUrl}in-transitview`, {id});
  }
}
